import React from 'react'
import './App.css'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import CustomerPage from './pages/Customer/Customer/CustomerPage'
import CreateCustomer from './pages/Customer/Customer/CreateCustomer'
import EditCustomer from './pages/Customer/Customer/EditCustomer'
import { Alert } from './ui/Alert'
import LoginPage from './pages/Login/LoginPage'
import CreateCountry from './pages/Hydrodrip/Countries/CreateCountry'
import CountryPage from './pages/Hydrodrip/Countries/CountryPage'
import EditCountry from './pages/Hydrodrip/Countries/EditCountry'
import CityPage from './pages/Hydrodrip/Cities/CityPage'
import CreateCity from './pages/Hydrodrip/Cities/CreateCity'
import EditCity from './pages/Hydrodrip/Cities/EditCity'
import HdEntityPage from './pages/Hydrodrip/HdEntities/HdEntityPage'
import CreateHdEntity from './pages/Hydrodrip/HdEntities/CreateHdEntity'
import EditHdEntity from './pages/Hydrodrip/HdEntities/EditHdEntity'
import ConsumerPage from './pages/Customer/Consumer/ConsumerPage'
import CreateConsumer from './pages/Customer/Consumer/CreateConsumer'
import EditConsumer from './pages/Customer/Consumer/EditConsumer'
import ZonePage from './pages/Meter/Zones/ZonePage'
import GroupeOfMeterPage from './pages/Meter/GroupOfMeter/GroupOfMeterPage'
import CreateGroupOfMeter from './pages/Meter/GroupOfMeter/CreateGroupOfMeter'
import EditGroupOfMeter from './pages/Meter/GroupOfMeter/EditGroupOfMeter'
import CreateZone from './pages/Meter/Zones/CreateZone'
import EditZone from './pages/Meter/Zones/EditZone'
import MeterPage from './pages/Meter/Meters/MeterPage'
import CreateMeter from './pages/Meter/Meters/CreateMeter'
import EditMeter from './pages/Meter/Meters/EditMeter'
import WaterCardPage from './pages/WaterCard/WaterCards/WaterCardPage'
import PermissionPage from './pages/Administrator/Permissions/PermissionPage'
import CreatePermission from './pages/Administrator/Permissions/CreatePermission'
import EditPermission from './pages/Administrator/Permissions/EditPermission'
import SubscriptionPage from './pages/Hydrowallet/Subscriptions/SubscriptionPage'
import CreateSubscription from './pages/Hydrowallet/Subscriptions/CreateSubscription'
import EditSubscription from './pages/Hydrowallet/Subscriptions/EditSubscription'
import CreateWaterCard from './pages/WaterCard/WaterCards/CreateWaterCard'
import EditWaterCard from './pages/WaterCard/WaterCards/EditWaterCard'
import TopUpWaterCard from './pages/Customer/TopUp/TopUpWaterCard'
import AdminPage from './pages/Administrator/Users/AdminPage'
import GroupPage from './pages/Administrator/Groups/GroupPage'
import CreateGroup from './pages/Administrator/Groups/CreateGroup'
import EditGroup from './pages/Administrator/Groups/EditGroup'
import RestrictionPage from './pages/WaterCard/Restictions/RestrictionPage'
import CreateCardPermission from './pages/WaterCard/Restictions/CreateCardPermission'
import EditCardPermission from './pages/WaterCard/Restictions/EditCardPermission'
import CreateUser from './pages/Administrator/Users/CreateUser'
import EditUser from './pages/Administrator/Users/EditUser'
import SettingPage from './pages/Setting/SettingPage'
import GeneralPage from './pages/Statistics/GeneralPage'
import AccountigPage from './pages/Statistics/AccountigPage'
import CyclePage from './pages/Statistics/CyclePage'
import ConsumptionPage from './pages/WaterCard/Consumptions/ConsumptionPage'
import Dashboard from './pages/DashBoard'
import { PageNotFound } from './pages/PageNotFound/PageNotFound'
import RechargePage from './pages/Customer/TopUp/RechargePage'
import EditSetting from './pages/Setting/EditSetting'
import PayBackPage from './pages/Customer/PayBack/PayBackPage'
import PayBackConsumer from './pages/Customer/PayBack/PayBackConsumer'
import TaskPage from './pages/Administrator/Task/TaskPage'
import PayBackConsumerConfirm from './pages/Customer/PayBack/PayBackConsumerConfirm'
import WaterMarketPage from './pages/Hydrowallet/WaterMarket/WaterMarketPage'
import SellWater from './pages/Hydrowallet/WaterMarket/SellWater'
import TransactionPage from './pages/Hydrowallet/Transaction/TransactionPage'

function App() {
  return (
    <Router>
      <Alert>
        <Switch>
          {/*Read*/}
          <Route exact path="/" component={LoginPage} />
          <Route exact path="/dashboard" component={Dashboard} />
          <Route exact path="/hydrodrip/countries" component={CountryPage} />
          <Route exact path="/hydrodrip/cities" component={CityPage} />
          <Route exact path="/hydrodrip/hd_entities" component={HdEntityPage} />
          <Route exact path="/clients/clients" component={CustomerPage} />
          <Route exact path="/clients/consumers" component={ConsumerPage} />
          <Route exact path="/meters/zones" component={ZonePage} />
          <Route exact path="/meters/meters" component={MeterPage} />
          <Route exact path="/meters/groups" component={GroupeOfMeterPage} />
          <Route exact path="/water_cards/digi_cards" component={WaterCardPage} />
          <Route exact path="/water_cards/restrictions" component={RestrictionPage} />
          <Route exact path="/hydrowallet/subscriptions" component={SubscriptionPage} />
          <Route exact path="/water_cards/consumptions" component={ConsumptionPage} />
          <Route exact path="/clients/top_up" component={RechargePage} />
          <Route exact path="/administrators/permissions" component={PermissionPage} />
          <Route exact path="/administrators/groups" component={GroupPage} />
          <Route exact path="/administrators/users" component={AdminPage} />
          <Route exact path="/settings" component={SettingPage} />
          <Route exact path="/clients/paybacks" component={PayBackPage} />
          <Route exact path="/statistics/general" component={GeneralPage} />
          <Route exact path="/statistics/accounting" component={AccountigPage} />
          <Route exact path="/statistics/cycle" component={CyclePage} />
          <Route exact path="/administrators/tasks" component={TaskPage} />
          <Route exact path="/hydrowallet/water_market" component={WaterMarketPage} />
          <Route exact path="/hydrowallet/transactions" component={TransactionPage} />
          {/*Create*/}
          <Route exact path="/hydrodrip/countries/create" component={CreateCountry} />
          <Route exact path="/hydrodrip/cities/create" component={CreateCity} />
          <Route exact path="/hydrodrip/hd_entities/create" component={CreateHdEntity} />
          <Route exact path="/clients/clients/create" component={CreateCustomer} />
          <Route exact path="/clients/consumers/create" component={CreateConsumer} />
          <Route exact path="/meters/zones/create" component={CreateZone} />
          <Route exact path="/meters/groups/create" component={CreateGroupOfMeter} />
          <Route exact path="/administrators/permissions/create" component={CreatePermission} />
          <Route exact path="/water_cards/restrictions/create" component={CreateCardPermission} />
          <Route exact path="/hydrowallet/subscriptions/create" component={CreateSubscription} />
          <Route exact path="/water_cards/digi_cards/create" component={CreateWaterCard} />
          <Route exact path="/administrators/users/create" component={CreateUser} />
          <Route exact path="/meters/meters/create" component={CreateMeter} />
          <Route exact path="/administrators/groups/create" component={CreateGroup} />
          <Route exact path="/hydrowallet/water_market/create" component={SellWater} />
          {/*Edit*/}
          <Route exact path="/hydrodrip/countries/edit/:id" component={EditCountry} />
          <Route exact path="/hydrodrip/cities/edit/:id" component={EditCity} />
          <Route exact path="/hydrodrip/hd_entities/edit/:id" component={EditHdEntity} />
          <Route exact path="/clients/clients/edit/:id" component={EditCustomer} />
          <Route exact path="/clients/consumers/edit/:id" component={EditConsumer} />
          <Route exact path="/meters/zones/edit/:id" component={EditZone} />
          <Route exact path="/administrators/permissions/edit/:id" component={EditPermission} />
          <Route exact path="/water_cards/restrictions/edit/:id" component={EditCardPermission} />
          <Route exact path="/hydrowallet/subscriptions/edit/:id" component={EditSubscription} />
          <Route exact path="/water_cards/digi_cards/edit/:id" component={EditWaterCard} />
          <Route exact path="/clients/top_up/create" component={TopUpWaterCard} />
          <Route exact path="/clients/paybacks/create" component={PayBackConsumer} />
          <Route exact path="/clients/paybacks/edit/:id" component={PayBackConsumerConfirm} />
          <Route exact path="/administrators/users/edit/:id" component={EditUser} />
          <Route exact path="/meters/meters/edit/:id" component={EditMeter} />
          <Route exact path="/meters/groups/edit/:id" component={EditGroupOfMeter} />

          <Route exact path="/administrators/groups/edit/:id" component={EditGroup} />
          <Route exact path="/settings/edit/:id" component={EditSetting} />
          <Route path="*" component={PageNotFound} />
        </Switch>
      </Alert>
    </Router>
  )
}

export default App
